import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchSignalProvidersKpi = async (user, startDate, endDate) => {
    try {
        const params = `?startDate=${startDate}&endDate=${endDate}`
        const { data } = await axios.get(`${API_BASE_URL}/copy-invest/kpi/signal-providers${params}`,
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const fetchSignalProviderFollowers = async (user, id, page, limit) => {
    try {
        const params = `?page=${page}&limit=${limit}`
        const { data } = await axios.get(`${API_BASE_URL}/copy-invest/signal-provider/${id}/followers${params}`,
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const fetchActiveCopyInvestors = async (user, page, limit) => {
    try {
        const params = `?page=${page}&limit=${limit}`
        const { data } = await axios.get(`${API_BASE_URL}/copy-invest/investors${params}`,
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const fetchSignalProviderInfos = async (user, id) => {
    try {
        const { data } = await axios.get(`${API_BASE_URL}/copy-invest/signal-provider/${id}/infos`,
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const updateSignalProviderInfos = async (user, id, payload) => {
    try {
        const { data } = await axios.put(`${API_BASE_URL}/copy-invest/signal-provider/${id}/infos`,
            payload,
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}